import { baseUrl } from '@/service/util';
import request from '@/utils/request';
import { setLocaleQuery } from '@/utils';

export const submitQuotation = (data: any, locale?: string) => {
    return request(`${baseUrl(locale)}/dpuForm/dp3${setLocaleQuery(locale)}`, {
        method: 'post',
        data,
        // needToken: true,
    });
};
